import { useParams } from "react-router-dom";
import { ListHandler } from "../components/lists/ListHandler";

export const ListViewHandler = () => {
  const { source } = useParams();
  return (
    <div className="p10">
      <ListHandler source={source} key={source} />
    </div>
  );
};
